import sectionMenuEventBubbler from "@/mixins/menu-event-bubblers/meb-section.mixin.js";
import _ from "lodash";

export default {
  mixins: [sectionMenuEventBubbler],
  data() {
    return {
      searchInput: null,
      filterPanels: [],
      reloadKey: 1,
    };
  },
  mounted() {
    this.closeFiltersOnEscapeListener = document.addEventListener(
      "keydown",
      (evt) => {
        if (this.menus && this.menus.filters && evt.code === "Escape")
          this.closeFilters();
      },
    );
  },
  beforeDestroy() {
    if (this.closeFiltersOnEscapeListener)
      document.removeEventListener(this.closeFiltersOnEscapeListener);
  },
  methods: {
    filterUpdate(event) {
      if (this.page) this.page = 1;
      this.listOptions[event.fieldName] = event.option;
      this.fetchList();
      this.reloadKey++;
    },
    filterMenuUpdate(event) {
      if (event) this.filterUpdate(event);
      else this.optionsUpdate();
      this.closeFilters();
    },
    removeFromFilter(listOption, value) {
      this.listOptions[listOption] = this.listOptions[listOption].filter(
        (item) => value != item,
      );
    },
    closeFilters() {
      if (this.menus) this.menus.filters = false;
      this.filterPanels = [];
      this.returnFocusToFilterCaret();
    },
    returnFocusToFilterCaret() {
      setTimeout(() => {
        const focusReturnEl =
          this.$refs.tableActiveFilters?.$refs?.tableActiveFiltersCaret?.$el;
        if (focusReturnEl) focusReturnEl.focus();
      }, 300);
    },
    orderUpdate(event) {
      if (this.page) this.page = 1;
      this.listOptions.order_by = event.fieldName;
      this.listOptions.order_direction = event.direction;
      this.fetchList();
      this.reloadKey++;
    },
    optionsUpdate() {
      if (this.page) this.page = 1;
      this.fetchList();
      this.reloadKey++;
    },
    setSearch: _.debounce(function () {
      this.listOptions.search_text = this.searchInput;
      this.fetchList();
      this.reloadKey++;
    }, 300),
    dateParam(dateOption) {
      const dates = dateOption.filter((date) => date);
      if (dates.length == 0) return null;
      if (dates.length == 1) return dates[0];
      else return dates;
    },
    searchInputEvent() {
      this.focusOnSearch = true;
      this.searchInput = this.searchInputBuffer;
    },
  },
  watch: {
    searchInput: {
      handler() {
        this.setSearch();
      },
    },
  },
};
